/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const ApiCommet = axios.create({ baseURL: 'https://apimapas.inmet.gov.br' });

export default ApiCommet;
